import { BingSession } from "./BingSession";
import { debounce } from "debounce";
import { readMapConfig } from "./map/MapConfig";
import { MapApp } from "./map/MapApp";

/**
 * Bootstrap for the main map page. All map behaviour lives in the modules
 * under Scripts/map — this file only reads config, sizes the container and
 * hands over to MapApp (deferring to the Bing session flow for members).
 */
// iOS Safari ignores user-scalable=no in the viewport tag, so a pinch that OpenLayers doesn't
// consume can zoom the whole page. Cancel Safari's gesture events so pinch only drives the map.
document.addEventListener('gesturestart', (event) => event.preventDefault(), { passive: false });
document.addEventListener('gesturechange', (event) => event.preventDefault(), { passive: false });

$(function () {
    const config = readMapConfig();
    const mapData = $("#mapData");
    const bingMapsApiKey: string = mapData.data("bingMapsApiKey");
    const bingSession = new BingSession();
    let app: MapApp = null;

    const resizeMap = function () {
        let height = $(window).height() - $("#mapContainer").offset().top - $("footer").height();
        if (height <= 400) {
            height = 400;
        }
        $('#mapContainer').height(height);
        //expose the map height so the slide panels can grow to the map bottom (see map.css)
        document.documentElement.style.setProperty('--tw-map-height', height + 'px');

        if (app) {
            app.olMap.updateSize();
        }
    };

    const loadMap = function (bingApiOrSessionKey: string, session: BingSession | null) {
        resizeMap();
        window.addEventListener('resize', debounce(resizeMap, 250));
        app = new MapApp(config, bingApiOrSessionKey, session);
    };

    const loadMapWithoutBing = function () {
        loadMap(null, null);
    };

    if (!config.isMember) {
        //unauth
        loadMap(bingMapsApiKey, bingSession);
    } else {
        //Called via callback on bing map control js file
        const loadMapWithBingSession = function () {
            bingSession.init(bingMapsApiKey,
                function (bingSessionKey) { loadMap(bingSessionKey, bingSession); },
                function () { loadMapWithoutBing(); }
            );
        };
        window["loadMapWithBingSession"] = loadMapWithBingSession;

        //deal with download failure of Bing Maps js
        window["loadMapWithoutBing"] = loadMapWithoutBing;
    }

    //resize map when user closes login alert
    var loginAlert = $('#content .alert:first-child');
    if (loginAlert[0] != null) {
        loginAlert[0].addEventListener('closed.bs.alert', function () {
            resizeMap();
        });
    }
});
